
import React, { useEffect, useState, useRef } from 'react'
import { Box, Divider, Grid, Typography, Button, Paper, IconButton, InputBase } from '@mui/material'
import { blueGrey, grey } from '@mui/material/colors'
import { getProfileExist } from '../../../services/user-services'
import Notification from "../../notification/notification"
import VpnKeyIcon from '@mui/icons-material/VpnKey'
import { secondsToHms, convertToFaToEn } from '../../../services/utils'
import CircularProgress from '@mui/material/CircularProgress';
import { debounce } from 'lodash';

// import dynamic from 'next/dynamic';
// const WaitingView = dynamic(
//     () => import("../../Maps/detail/common/Progress/back-drop"),
//     { ssr: false }
// )


// const Item = styled(Paper)(({ theme }) => ({
//     backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
//     ...theme.typography.body2,
//     padding: theme.spacing(1),
//     textAlign: 'center',
//     color: theme.palette.text.secondary,
// }))


function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export default function ForgetSMSCode({ userPhone, num_check, typeSMS, onBack, onChangeNum}) {
    // const { onNext, onBack, famili, user_name } = props
    // const timerNow = useTimer(12)
    // const [mobileNumber, setMobileNumber ] = useState<string>('')
    const [SMSCode, setSMSCode ] = useState('')
    // const [timerRemain, setTimerRemain] = useState<number>(0)
    const [loading, setLoading ] = useState(false)
    
    let [seconds, setSeconds] = useState(180),
        [timer, setTimer] = useState();
    
    const [notiShow, setNotiShow] = useState(false)
    const [notiTitle, setNotiTitle] = useState('')
    const [notiType, setNotiType] = useState("success")
    const inputRef = useRef();
  
    useEffect(() => {
      inputRef.current?.focus();
    }, [inputRef]);
  
    const setTextInputRef = (element) => {
      inputRef.current = element;
    };

    const handleNext = async (codeSMS) => {
        inputRef.current?.focus();
        setLoading(true)
        let items = {
            phone: userPhone, 
            sms_: codeSMS
        }
        if(typeSMS === 1)
        {
            items = {
                phone: userPhone, 
                sms_code: codeSMS
            }
        }
        // console.log(items);
        
        await getProfileExist(items)
        .then(res => {
            // console.log(res?.message);
            if(res && res?.message === "Ok"){
                const dataRes = {
                    sms_code: codeSMS, 
                    mobile_number: userPhone,
                    num_check: num_check,
                    type_sms: typeSMS
                    // token: res?.token ? res?.token : ''
                }
                onBack(dataRes)
            }else if(res?.message){
                setNotiShow(true)
                setNotiTitle(res?.message)
                setNotiType("error")
            }
            setLoading(false)
        }).catch(err =>{
            setLoading(false)
        })
    }
      
    useEffect(() => {
        // console.log(seconds);
        
        if (seconds > 0) updateSeconds();
        else {
          // go to next page
          // set timer
          // setSeconds(15);
          setTimer(null);
        }
    
        // eslint-disable-next-line
      }, [seconds]);
    
      /* Timer Logic */
    function updateSeconds() {
        let timeOut = setTimeout(() => {
            setSeconds(seconds - 1);
        }, 1000);

        setTimer(timeOut);
    }

    const handleSMSCode = async () => {
        if(seconds > 0)
        {
            return
        }
        inputRef.current?.focus();
        let items = {
            phone: userPhone, 
            forget: "Ok"
        }
        if(typeSMS === 1)
        {
            items = {
                phone: userPhone, 
                registery: "Ok"
            }
        }
        setSeconds(180)
        // console.log('typeSMS', typeSMS);
        setLoading(true)
        await getProfileExist(items)
        .then(res => {
            // console.log(res?.message);
            if(res && res?.message === "Ok"){
                // const dataRes = {code_prs: codePrson, mobileNumber: mobileNumber}
                // onNext(dataRes)
                // setTimerRemain(120)
                // handleStart()
                setNotiShow(true)
                setNotiTitle('کد تأیید پیامک شد')
                setNotiType("success")
                setSeconds(180)
            }else if(res?.message){
                setNotiShow(true)
                setNotiTitle(res?.message)
                setNotiType("error")
                // setSeconds(0)
            }
            setLoading(false)
        })
        .catch(err =>{
            setLoading(false)
        })
    }
    
    const handlerBackNoti = () => {
        setNotiShow(false)
    }

    const handleBack = () => {
        inputRef.current?.focus();
        onChangeNum(true)
    };

    
        const handleChange = (e) => {
            const re = /^[0-9۰-۹]+$/;
            const inputValue = convertToFaToEn(String(e.target.value));
            if (re.test(inputValue) && inputValue.length <= 11 && !inputValue.startsWith('0')) {
                setSMSCode(inputValue)
                debouncedHandlerNextSMSCode(inputValue);
            } else {
                setSMSCode("")
                setNotiShow(true)
                setNotiTitle('لطفا با اعداد انگلیسی بنویسید')
                setNotiType("error")
            }
        };
        
        const debouncedHandlerNextSMSCode = debounce((inputValue) => {
            
            if (inputValue.length >= 6) {
                handleNext(inputValue);
            }
        }, 300);
    // useEffect(() => {    
    //     setLoading(false)
    // }, [loading])

  return (
    
    <Box 
        sx={{  
            bgcolor: 'background.paper', 
        }}
        >
        {loading &&
            // <WaitingView openWait={loading} onCloseClick={false} />
            <CircularProgress />
        }
                
        <div dir='rtl' style={{textAlign: 'right'}}>
        <Paper 
            elevation={3}
            >
                
            <Box component="section" sx={{ p: 2 }}>
                <div className='pb-5 -mt-5'>
                    <Typography 
                        fontFamily='vaziri' 
                        component="div"
                        variant="h6"
                        color={grey[900]}
                        >
                        کد تأیید را وارد کنید
                    </Typography>
                </div>
                <div className='pb-3'>
                    <Typography 
                        fontFamily='vaziri_light' 
                        component="span"
                        variant="body2"
                        color={grey[700]}
                        >
                        {'کد پیامک‌ شده به شمارۀ '} 
                    </Typography>
                    <Typography 
                        fontFamily='b_mitra' 
                        component="span"
                        variant="h6"
                        color={blueGrey[800]}
                        >
                        {`« ${userPhone} »`}
                    </Typography>
                    <Typography 
                        fontFamily='vaziri_light' 
                        component="span"
                        variant="body2"
                        color={grey[700]}
                        >
                        {' را وارد کنید.'}
                    </Typography>
                </div>
            </Box>
            <div className='w-full text-center items-center px-10' dir='rtl'>
                <Paper
                    // component="form"
                    sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: '100%' }}
                    >
                    <InputBase
                        sx={{ ml: 1, flex: 1, fontSize: 16, textAlign: 'center'}}
                        placeholder={'کد پیامک تایید'}
                        inputProps={{ 
                            'aria-label': 'search ', 
                            fontSize: 22,
                            style:{
                                fontSize: 24,
                                fontFamily:'b_mitra',
                            } 
                        }}
                        inputRef={setTextInputRef} 
                        onChange = {handleChange}

                        />
                    {/* <IconButton type="button" sx={{ p: '10px' }} aria-label="search">
                        <PhoneCallbackIcon />
                    </IconButton> */}
                    <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                    <IconButton color="primary" sx={{ p: '10px' }} aria-label="directions">
                        <VpnKeyIcon />
                    </IconButton>
                </Paper>
            </div>
            <div className='w-full text-right items-right' dir='rtl'>
                <Button variant="outlined" 
                    color="primary" 
                    sx={{m: 2}}
                    onClick={handleBack}
                    >
                    <Typography 
                        fontFamily="vaziri_light"
                        component="span"
                        variant="h6"
                        color='primary'
                        >
                        {"تغییر شماره همراه"}
                        {/* {authDataLang?.site_langs?.desc_buttom_accept} */}
                    </Typography>
                </Button>
            </div>

            {/* <Grid container spacing={2}>
                <Grid item > */}
            <Grid container spacing={1} alignItems='flex-start' sx={{ p:2, textAlign: 'left'}}>
                <Grid item xs={6}>
                    <Button variant="outlined" 
                        color="primary" 
                        sx={{m: 2}}
                        disabled={seconds>0}
                        onClick={handleSMSCode}
                        >
                        <Typography 
                            fontFamily="b_mitra"
                            component="span"
                            variant="h6"
                            color={"secondary"}
                            noWrap
                            >
                            {seconds > 0 ? `درخواست کد ${secondsToHms(seconds)}` : "درخواست کد"}
                            {/* {authDataLang?.site_langs?.desc_buttom_accept} */}
                        </Typography>
                    </Button>
                </Grid>
                <Grid item xs={6}>
                    <Button variant="contained" 
                        color="primary" 
                        sx={{m: 2, px: 5}}
                        disabled={!SMSCode}
                        onClick={() => handleNext(SMSCode)}
                        >
                        <Typography 
                            fontFamily="vaziri"
                            component="span"
                            variant="h6"
                            color={blueGrey[50]}
                            >
                            تایید
                            {/* {authDataLang?.site_langs?.desc_buttom_accept} */}
                        </Typography>
                    </Button>
                </Grid>
            </Grid>
            </Paper>
            <div>
                <Notification
                    viewNoti={notiShow}
                    title={notiTitle} 
                    severity={notiType}
                    onBack={handlerBackNoti}
                    />
            </div>
        </div>
    </Box>
    
    );
}
